import React, { Component } from 'react';
import { connect } from "react-redux";

import './companyWidget.css';
import Carousel from '../carousel/carousel';

class CompanyWidget extends Component {
  constructor(props) { // active tab
    super(props);
    this.state = { active: 'logo' };
  }
  setActive = activePage => {
    this.setState({active: activePage})
  }
  render() {
    const { active } = this.state;
    const { user } = this.props;
    return(
      <div className='widget carousel small speechBubble'>
        {this.renderCarousel(active) }
        <Carousel items={['logo', 'tagLine']} active={active} onClick={this.setActive} />
      </div>
    )
  }
  renderCarousel(active) {
    const { companyInfo } = this.props;
    if(active === 'logo') {
      return <img id='logo' src={companyInfo.logo} />
    } else {
      return <div className='flex-grow'><h3 className='center'>{companyInfo.tagline}</h3></div>
    }
  }
}

export default connect(state => {
  return {
    companyInfo: state.general.company.info,
    user: state.general.user
  }
})(CompanyWidget);
